export const CMS_TYPES = {
    terms: 'terms',
    policy: 'privacy',
    faq: 'faq',
    landingImage: 'landing_images',
    howToOrder: 'how_to_order',
    appsettings: "appsettings"
}
export const CMS_JSON_PATH ="common_assets/cms/v-0.0.1.json"
export const CMS_JSON_TYPE ="cms_json"
export const CMS_MEDIA_TYPE ="cms_media"
export const ISEMBED ="youtube.com/embed"